module.exports = __webpack_public_path__ + "img/bg-header.acdd4fe.png";